// Types

import { InviteRuleItem } from "../types/Invite";

export const INVITE_RULES: InviteRuleItem[] = [
  {
    id: 1,
    title: "referral.rules.participate",
    description: [
      "referral.rules.participate.1",
      "referral.rules.participate.2",
      "referral.rules.participate.3",
      "referral.rules.participate.4",
    ],
  },
  {
    id: 2,
    title: "referral.rules.procedure",
    description: [
      "referral.rules.procedure.1",
      "referral.rules.procedure.2",
      "referral.rules.procedure.3",
      "referral.rules.procedure.4",
      "referral.rules.procedure.5",
      "referral.rules.procedure.6",
      "referral.rules.procedure.7",
      "referral.rules.procedure.8",
      "referral.rules.procedure.9",
      "referral.rules.procedure.10",
    ],
  },
  {
    id: 3,
    title: "referral.rules.obligations",
    description: [], // Empty since this will have nested items
    nestedItems: [
      {
        id: 31,
        title: "referral.rules.obligations.participant",
        description: [
          "referral.rules.obligations.participant.1",
          "referral.rules.obligations.participant.2",
          "referral.rules.obligations.participant.3",
          "referral.rules.obligations.participant.4",
          "referral.rules.obligations.participant.5",
        ],
      },
      {
        id: 32,
        title: "referral.rules.obligations.organizer",
        description: [
          "referral.rules.obligations.organizer.1",
          "referral.rules.obligations.organizer.2",
          "referral.rules.obligations.organizer.3",
          "referral.rules.obligations.organizer.4",
          "referral.rules.obligations.organizer.5",
          "referral.rules.obligations.organizer.6",
        ],
      },
    ],
  },
];

export const REFERRAL_LIST = [
  {
    referralId: 1,
    referrerId: 2,
    profit: 0,
    removalReason: "",
    createdAt: "",
    updatedAt: "",
  },
  {
    referralId: 1,
    referrerId: 2,
    profit: 0,
    removalReason: "",
    createdAt: "",
    updatedAt: "",
  },
  {
    referralId: 1,
    referrerId: 2,
    profit: 0,
    removalReason: "",
    createdAt: "",
    updatedAt: "",
  },
  {
    referralId: 1,
    referrerId: 2,
    profit: 0,
    removalReason: "",
    createdAt: "",
    updatedAt: "",
  },
  {
    referralId: 1,
    referrerId: 2,
    profit: 0,
    removalReason: "",
    createdAt: "",
    updatedAt: "",
  },
];
